import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import { TemplateSection } from '@/components/Editor/Form/fields/Template';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var EditCircleIcon = function EditCircleIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_12814_1137)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M21.5999 12.1875C21.5999 17.4894 17.3018 21.7875 11.9999 21.7875C6.69797 21.7875 2.3999 17.4894 2.3999 12.1875C2.3999 6.88556 6.69797 2.58749 11.9999 2.58749C17.3018 2.58749 21.5999 6.88556 21.5999 12.1875Z",
        fill: "#C3C9D1"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 0.1875C10.6745 0.1875 9.6 1.26202 9.6 2.5875C9.6 3.91298 10.6745 4.9875 12 4.9875C13.3255 4.9875 14.4 3.91298 14.4 2.5875C14.4 1.26202 13.3255 0.1875 12 0.1875ZM2.4 9.7875C1.07452 9.7875 0 10.862 0 12.1875C0 13.513 1.07452 14.5875 2.4 14.5875C3.72548 14.5875 4.8 13.513 4.8 12.1875C4.8 10.862 3.72548 9.7875 2.4 9.7875ZM19.2 12.1875C19.2 10.862 20.2745 9.7875 21.6 9.7875C22.9255 9.7875 24 10.862 24 12.1875C24 13.513 22.9255 14.5875 21.6 14.5875C20.2745 14.5875 19.2 13.513 19.2 12.1875ZM12 19.3875C10.6745 19.3875 9.6 20.462 9.6 21.7875C9.6 23.113 10.6745 24.1875 12 24.1875C13.3255 24.1875 14.4 23.113 14.4 21.7875C14.4 20.462 13.3255 19.3875 12 19.3875Z",
        fill: "black"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_12814_1137",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0 0.1875)"
        })
      })
    })]
  }));
};

EditCircleIcon.defaultProps = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const EditorFormFieldsRadius = _ref => {
  let {
    nameSpace,
    exampleValue,
    pointTemplate,
    defaultTemplate,
    openButtonVariant,
    onChange
  } = _ref;
  const templateId = `${nameSpace}-radius-template`;
  return /*#__PURE__*/_jsx(RevealPill, {
    label: "Radius",
    openButtonVariant: openButtonVariant,
    activeState: /*#__PURE__*/_jsx(EditCircleIcon, {}),
    children: /*#__PURE__*/_jsx(TemplateSection, {
      id: templateId,
      label: "Formatting",
      caption: "How point data will be presented",
      exampleValue: exampleValue,
      template: pointTemplate ?? defaultTemplate,
      onChange: value => onChange({
        pointTemplate: value
      })
    })
  });
};

export default EditorFormFieldsRadius;